import {Component, OnInit} from '@angular/core';
import {SharedService} from '../shared/shared.service';
import {LocalStorageService} from 'angular-2-local-storage';
import {ActivatedRoute, Router, } from '@angular/router';
import {UsagePaymentsService} from '../payment/usage-payments/usage-payments.service';
import {MatDialog} from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import {DatePipe, TitleCasePipe} from '@angular/common';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';

declare var $: any;
declare var document: any;

@Component({
  selector: 'app-usage-details',
  templateUrl: './usage-details.component.html',
  styleUrls: ['./usage-details.component.css']
})
export class UsageDetailsComponent implements OnInit {

  public isClicked: boolean;
  public is_acc_terminated: boolean;
  public person_detail: any;
  public account_no: number;
  public username: any;
  public status: any;
  public account_status: any;
  public street_address1: any;
  public street_address2: any;
  public short_address: any;
  public customer_since: any;
  public acc_end_date: any;
  public service_start_date: any;
  public ser_acc_bal: any;
  public dpp_bal: any;
  public dab_bal: any;
  public esi_id: any;
  public user_id: any;
  public transactionSummary: any;
  public data_list: any;
  public service_list: any;
  public is_monthly_stat: boolean;
  public is_get_statement: boolean;
  public is_loader: boolean;
  public is_detail_loader: boolean;
  public headerLineItems: Array<SupHeader>;
  public tempDetailItems: Array<SUPDetail>;
  public formatter: any;
  public month: string;
  public year: string;
  public sub: any;
  public panels: boolean[] = [];
  public panelOpenState: boolean[] = [];
  public detailLoaderState: boolean[] = [];

  constructor(public dialog: MatDialog, private activatedRoute: ActivatedRoute, private titlecasePipe: TitleCasePipe,
              private sharedService: SharedService, private localStorageService: LocalStorageService,
              private router: Router, private usagePaymentsService: UsagePaymentsService) {

    // Create our number formatter.
    this.formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',

      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    this.sharedService.setHeaderTitleDynamicVal('usage_payments', 'Usage History', '');
    if (this.localStorageService.get('token') != null) {
      this.data_list = [];
      this.is_monthly_stat = false;
      this.is_get_statement = false;
      this.is_loader = true;
      this.isClicked = false;
      this.ser_acc_bal = 0.0;
      this.dpp_bal = 0.0;
      this.dab_bal = 0.0;
      this.sharedService.verifyToken({'token': this.localStorageService.get('token')})
        .then(res => {
          this.sharedService.setHeaderTitle('default_page');
          if (res.status === 'success' && res.isTerminated === false) {
            if (!res.isEnrolled) {
              this.router.navigate(['./dashboard']);
            } else {
              const person = res.results[0]['personal'][0];
              this.user_id = person['id'];
              this.ser_acc_bal = person.balance;
              this.username = person.firstName + ' ' + person.lastName;
              this.username = this.titlecasePipe.transform(this.username);
              this.street_address1 = person.billingAddress;
              this.street_address2 = person.city + ', ' + person.state + ' ' + person.zipCode;
              this.account_no = person.accountNumber;
              const service = res.results[0]['service'][0];

              if (service) {
                this.customer_since = service.serviceStartDate;
                this.esi_id = service.esiId;
              }

              const that = this.sharedService;
              this.dpp_bal = res.results[0]['dppBalance'];
              this.is_acc_terminated = res.isTerminated;
              if (service.status == null) {
                this.status = '';
              } else {
                this.status = service.status.replace('_', ' ');
              }
              if (person.accountStatusName == null) {
                this.account_status = '';
              } else {
                this.account_status = person.accountStatusName.replace('_', ' ');
              }
              this.service_start_date = new DatePipe('en-US').transform(service.serviceStartDate, 'MM/dd/yyyy');
              if (this.is_acc_terminated) {
                this.acc_end_date = new DatePipe('en-US').transform(service.dateModified, 'MM/dd/yyyy');
              }
              this.service_list = this.getShortAddress(res.results[0]['service']);
              setTimeout(function () {
                that.setHeaderErrorMessage('usage_payments', false, 'notification error', '');
                that.setHeaderUserLoggedIn('usage_payments', true, person);
              }, 10);

              const data = {};
              this.data_list = [];

              data['token'] = this.localStorageService.get('token');

              this.sub = this.activatedRoute
                .queryParams
                .subscribe(params => {

                  this.month = params['month'];
                  this.year = params['year'];

                });

              data['selMonth'] = this.month;
              data['selYear'] = this.year;


              this.usagePaymentsService.getSupHeaderLineItems(data)
                .then(res1 => {
                  this.headerLineItems = res1.result;
                  this.is_loader = false;

                  // loop to add panels
                  for (let i = 0; i < this.headerLineItems.length; i++) {
                    this.panelOpenState.push(false);
                    this.detailLoaderState.push(false);

                  }
                });
            }
          } else {
            this.localStorageService.remove('token');
            this.router.navigate(['./sign-in']);
          }
        });
    } else {
      this.router.navigate(['./sign-in']);
    }
  }

  ngOnInit() {


  }

  goBack() {
    this.router.navigate(['./usage-payments']);
  }

  getShortAddress(serviceArry: any) {
    serviceArry.forEach(service => {
      if (service.address.length > 20) {
        service.address = service.address + '#~#' + service.address.substring(0, 17) + '...';
        if (service.address2 != null && service.address2 != '') {
          service.address = service.address + service.address2
        }
      }

      while (service.address.charAt(0) === '0') {
        service.address = service.address.substr(1);
      }
    });
    return serviceArry.sort();
  }

  getDetails(header: SupHeader, panelOpenState: boolean, index: number) {

    if (panelOpenState == true && header.supDetailLineItems == undefined) {

      const data = {};
      this.data_list = [];
      this.detailLoaderState[index] = true;

      data['token'] = this.localStorageService.get('token');
      data['header'] = header;

      if (header.supDetailLineItems == undefined) {
        this.usagePaymentsService.getSupDetailLineItems(data)
          .then(res1 => {

            header.supDetailLineItems = res1.result;
            this.detailLoaderState[index] = false;
          });
      }

    } else {

    }

  }
}

export interface SupHeader {
  date: any;
  ban: string;
  glId: number;
  invoiceId: number;
  parentDescription: string;
  invoiceType: string;
  glAmount: number;
  glBalance: number;
  transactionType: string;
  supDetailLineItems: SUPDetail[];
}


export interface SUPDetail {
  id: number;
  glId: number;
  saId: number;
  description: string;
  amount: number;
  transactionType: string;
  invoiceType: string;
  uomid: number;
  chargeCategoryId: number;
  chargeTypeId: number;
  isReconPogoCharge: boolean;
  isReconUtiilityCharge: boolean;
  ban: number;
  isBold: boolean;

}





// WEBPACK FOOTER //
// ./src/app/usage/usage-details.component.ts